import React from "react";
import {
  BookOpen,
  ArrowRight,
  Clock3,
  User,
} from "lucide-react";
import HomeNavbar from "../HomeNavbar";
import Footer from "../Footer";
import blogs from "./blogData";
import { Link, useNavigate } from "react-router-dom";

function BlogPage() {
  const featuredBlog = blogs[0];
  const navigate = useNavigate();

  return (
    <>
      <HomeNavbar />

      <div className="min-h-screen bg-[#faf8fd]">

        {/* Hero */}
        <section className="bg-gradient-to-r from-[#4B2D83] to-[#6B46C1] py-10">
          <div className="max-w-7xl mx-auto pt-10 px-5 text-center">

            <span className="inline-flex items-center gap-2  px-4 py-2 rounded-full bg-white/10 text-white text-sm">
              <BookOpen size={16} />
              Adhyayi Learning Blog
            </span>

            <h1 className="mt-6 text-4xl md:text-6xl font-bold text-white">
              Adhyayi Learning Hub
            </h1>

            <p className="mt-6 text-lg md:text-xl text-purple-100 max-w-3xl mx-auto">
              Explore insights on Learning With Earning,
              competitive exam preparation, performance tracking,
              contests, rewards and the complete Adhyayi ecosystem.
            </p>

          </div>
        </section>

        {/* Featured Blog */}
     <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
  <div className="bg-white rounded-3xl shadow-xl overflow-hidden">

    <div className="grid lg:grid-cols-2 gap-0 items-center">

      {/* Image */}
      <div className="flex justify-center items-center p-6 md:p-10 bg-gradient-to-br from-purple-50 to-white">

        <img
          src={featuredBlog.featuredImage}
          alt={featuredBlog.title}
          className="
            w-full
            max-w-[550px]
            h-auto
            object-contain
            hover:scale-105
            transition-all
            duration-300
          "
        />

      </div>

      {/* Content */}
      <div className="p-6 md:p-10 lg:p-12">

        <span className="inline-flex items-center px-4 py-2 rounded-full bg-purple-100 text-[#4B2D83] text-sm font-semibold">
          Featured Article
        </span>

        <h2 className="mt-5 text-2xl md:text-4xl font-bold text-gray-900 leading-tight">
          {featuredBlog.title}
        </h2>

        <p className="mt-5 text-gray-600 leading-7 text-base">
          {featuredBlog.summary}
        </p>

        <div className="flex flex-wrap items-center gap-6 mt-6 text-gray-500">

          <div className="flex items-center gap-2">
            <User size={18} />
            <span>{featuredBlog.authorName}</span>
          </div>

          <div className="flex items-center gap-2">
            <Clock3 size={18} />
            <span>{featuredBlog.readingTime} min read</span>
          </div>

        </div>

        <button
          onClick={() =>
            navigate("/blog/what-is-adhyayi-complete-guide")
          }
          className="
            mt-8
            inline-flex
            items-center
            gap-2
            bg-[#4B2D83]
            text-white
            px-6
            py-3
            rounded-xl
            font-semibold
            hover:bg-[#3b2267]
            transition-all
          "
        >
          Read Full Article
          <ArrowRight size={18} />
        </button>

      </div>

    </div>

  </div>
</section>

        {/* Blogs */}
        <section className="max-w-7xl mx-auto px-5 pb-20">

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

            {blogs.map((blog) => (
              <div
                key={blog.id}
                className="
                group
                bg-white
                rounded-3xl
                overflow-hidden
                border
                border-purple-100
                hover:border-[#4B2D83]
                shadow-sm
                hover:shadow-xl
                transition-all
                duration-300
                "
              >

                <div className="overflow-hidden">
                  <img
                    src={blog.featuredImage}
                    alt={blog.title}
                    className="
                    w-full
                    h-56
                    object-cover
                    group-hover:scale-105
                    transition-transform
                    duration-500
                    "
                  />
                </div>

                <div className="p-6">

                  <span className="inline-flex px-3 py-1 rounded-full bg-purple-100 text-[#4B2D83] text-sm font-medium">
                    {blog.category}
                  </span>

                  <h3 className="text-xl font-bold mt-4 line-clamp-2">
                    {blog.title}
                  </h3>

                  <p className="text-gray-600 mt-3 line-clamp-3">
                    {blog.description}
                  </p>

                  <div className="flex items-center justify-between mt-5 text-sm text-gray-500">

                    <div className="flex items-center gap-2">
                      <User size={16} />
                      {blog.author}
                    </div>

                    <div className="flex items-center gap-2">
                      <Clock3 size={16} />
                      {blog.readTime}
                    </div>

                  </div>

                <Link
  to={`/blog/${blog.slug || blog.id}`}
  className="mt-5 flex items-center gap-2 text-[#4B2D83] font-semibold"
>
  Read More
  <ArrowRight size={16} />
</Link>

                </div>

              </div>
            ))}

          </div>

        </section>

        {/* CTA */}
        <section className="bg-[#4B2D83] py-20">

          <div className="max-w-4xl mx-auto text-center px-5">

            <h2 className="text-4xl md:text-5xl font-bold text-white">
              Start Your Learning With Earning Journey
            </h2>

            <p className="mt-5 text-lg text-purple-100">
              Learn, Practice, Compete, Track Performance
              and Unlock Reward Opportunities.
            </p>

            <button className="mt-8 px-8 py-4 bg-white text-[#4B2D83] rounded-xl font-semibold hover:scale-105 transition">
              Explore Adhyayi
            </button>

          </div>

        </section>

      </div>

      <Footer />
    </>
  );
}

export default BlogPage;